// extracted by mini-css-extract-plugin
module.exports = {"container":"MainLogo_container_32_SU","title":"MainLogo_title_n1yR3"};